import { CommonModule } from '@angular/common';
import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { TablePriceListComponent } from '../table-price-list/table-price-list.component';
import SalesOrganizationAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity';
import { SalesOrganizationService } from 'app/modules/components/configuration/sales-organization/sales-organization.component.service';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import PriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity';
import { PriceListService } from '../../price-list/price-list.service';
import { IAPIListResult, IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MaterialPriceListService } from '../strategy-price-list.service';
import MaterialPriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity';
import { CompanyAttributes, CurrencyAttributes, MaterialAttributes } from '@albatrosdeveloper/ave-models-package';
import { MaterialService } from 'app/modules/components/material/material/material.service';
import { environment } from 'environments/environment.prod';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import UnitMeasurementsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements/unit-measurements.entity';
import AlternalUnitMeasurementAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { ConditionClassEnum } from '../condition-class-enum';
import { UnitMeasureService } from '../../unit-of-measurement/unit-of-measurement.service';
import { MatBadgeModule } from '@angular/material/badge';
import { buildQuery, Ops, where } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { CompanyService } from 'app/modules/components/configuration/company/company.service.service';
import { SequenceReadingService } from '../sequence-reading.service';
import { CompanyCurrencyPipe } from 'app/pipes/currency.pipe';

@Component({
  selector: 'app-setting-price-list',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    TablePriceListComponent,
    NgxMatSelectSearchModule,
    MatBadgeModule,
    CompanyCurrencyPipe
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './setting-price-list.component.html',
  styleUrl: './setting-price-list.component.scss'
})
export class SettingPriceListComponent {
  
  sequencePrice: string = 'S2'
  sequenceLiquidation: string = 'S1'

  //TAB 1
  displayedColumnsPriceList: string[] = [ 
    "unitMeasure",
    "priceList",
    "price",
    "scalePrices", 
    "action"
  ];

  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof MaterialPriceListAttributes = "dateEnd";
  sortDirection: "ASC" | "DESC" = "ASC";

  dataSourcePriceList = new MatTableDataSource<MaterialPriceListAttributes>([])
  @ViewChild("addPriceListModal") addPriceListModal!: TemplateRef<any>;
  @ViewChild("editPriceListModal") editPriceListModal!: TemplateRef<any>;
  
  currentCreatePriceList: any = this.initializeCreatePriceList(); //TODO
  currentUpdatePriceList: MaterialPriceListAttributes | undefined;

  //TAB 2
  displayedColumnsLiquidationList: string[] = [
    "field8",
    "price", 
    "action"
  ];

  totalItemsLiquidation = 0
  searchLiquidation: string = ''
  pageSizeLiquidation = 50
  pageIndexLiquidation: number = 1;
  sortActiveLiquidation: keyof MaterialPriceListAttributes = "dateEnd";
  sortDirectionLiquidation: "ASC" | "DESC" = "ASC";

  dataSourceLiquidationList = new MatTableDataSource<any>([])
  @ViewChild("addLiquidationListModal") addLiquidationListModal!: TemplateRef<any>;
  @ViewChild("editLiquidationModal") editLiquidationModal!: TemplateRef<any>;

  currentCreateLiquidationList: any = this.initializeCreateLiquidationList(); //TODO
  currentUpdateLiquidationList: MaterialPriceListAttributes | undefined;

  //filter
  salesOrganizationList: SalesOrganizationAttributes[] = [];

  priceList: PriceListAttributes[] = [];
  listFilterPriceList: PriceListAttributes[] = []
  searchPriceList = ''

  materialList: MaterialAttributes[] = [];
  searchMaterial = ''
  private searchSubject = new Subject<string>();

  unitMeasureList: AlternalUnitMeasurementAttributes[] = []

  rangeList: {code: string; name: string}[] = [
    {code: '0-6', name: '0-6'},
    {code: '6-12', name: '6-12'},
    {code: '12-18', name: '12-18'}
  ]

  listFilterCurrency: CurrencyAttributes[] = []

  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  constructor(
    private materialPriceListService: MaterialPriceListService,
    private readonly sequenceReadingService: SequenceReadingService,
    private readonly salesOrganizationService: SalesOrganizationService,
    private readonly priceListService: PriceListService,
    private readonly materialService: MaterialService,
    private readonly unitService: UnitMeasureService,
    private readonly companyService: CompanyService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<SettingPriceListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("90%")
    this.getSequence()
  }

  applyFilter(filterValue: string, type) {
    if(type == 'P'){
      this.pageIndex = 1
      this.search = filterValue
      this.getMaterialPriceList()
    }else if(type == 'L'){
      this.pageIndexLiquidation = 1
      this.searchLiquidation = filterValue
      this.getLiquidationList()
    }
  }

  private getSequence(): void {
    const options = {
      search: null,
      currentPage: 1,
      limitPerPage: 50,
      //sortActive: "name",
      //sortDirection: "ASC"
    };

    this.sequenceReadingService.findAllWithCount(
      options,
      ConditionClassEnum.XP01
    ).subscribe({
      next: (res: IAPIListResult<any>) => {
        if (Array.isArray(res.data) && res.data.length > 0 && Array.isArray(res.data[0]?.sequences) && res.data[0].sequences.length > 0) {
          const sequences = res.data[0].sequences;

          this.sequencePrice = sequences.find(seq => seq.sequence === 'S2')?.sequence || 'S2'; //S2
          this.sequenceLiquidation = sequences.find(seq => seq.sequence === 'S1')?.sequence || 'S1'; //S1
        }

        this.getMaterialPriceList()
        this.getLiquidationList()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener secuencias.","Cerrar",{ duration: 5000});
      },
    });
  }

  //TAB1
  getMaterialPriceList(){
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }
    let conditionClass = ConditionClassEnum.XP01

    this.materialPriceListService.findAllWithCount(options, this.data.materialId, conditionClass, this.sequencePrice).subscribe({
      next: (res: IPaginationResult<MaterialPriceListAttributes>) => {
        this.dataSourcePriceList.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;

        /* this.dataSourcePriceList.data.forEach((item: any) =>{
          this.getMaterialId(item.field6).then((details) => {
            item.materialDetail = details;
          });
        }) */

        /* this.dataSourcePriceList.data.forEach((item:any) => {
          this.getPriceListId(item.field4).then((details) => {
            item.priceList = details;
          })
        })

        this.dataSourcePriceList.data.forEach((item:any) => {
          this.getUnitMeasureId(item.field7).then((details) => {
            item.unitMeasure = details;
          })
        }) */
      
      },
      error: (err) => {
        this.dataSourcePriceList.data = []
        this.snackBar.open(err.error.message || "Error al obtener lista de precios","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction.toUpperCase() || 'ASC'
    this.getMaterialPriceList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getMaterialPriceList()
  }

  initializeCreatePriceList(){
    return {
      distributionChainId: "", 
      priceListId: "", 
      itemId: "", 
      unitMeasureId:"", 
      currencyId: "",
      // dateStart:null, dateEnd:null, 
      price: null, scalePrices: []}
  }

  openCreatePriceList(){
    this.getServicesCombo('create', true)
    this.rangeCreatePriceList.reset();
    this.dialog.open(this.addPriceListModal, { width: '90%', disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.createPriceListe());
  }

  updateFormPriceList(event){
    if(Array.isArray(event)){
      this.currentUpdatePriceList.scalePrices = event //.map((div => div._id))
      this.currentUpdatePriceList.hasScalePrices = this.currentUpdatePriceList.scalePrices && this.currentUpdatePriceList.scalePrices.length > 0 ? true : false  
    }
  }

  createPriceListe(){
    this.createMaterialPriceList(this.currentCreatePriceList, this.sequencePrice, ConditionClassEnum.XP01, 'P');
  }

  //TAB2
  getLiquidationList(){
    let options = { currentPage: this.pageIndexLiquidation, limitPerPage: this.pageSizeLiquidation, search: this.searchLiquidation, sort: this.sortActiveLiquidation, sortDirection: this.sortDirectionLiquidation }
    let conditionClass = ConditionClassEnum.XP01

    this.materialPriceListService.findAllWithCount(options, this.data.materialId, conditionClass, this.sequenceLiquidation).subscribe({
      next: (res: IPaginationResult<MaterialPriceListAttributes>) => {
        this.dataSourceLiquidationList.data = res?.data?.[0]?.data ?? [];
        this.totalItemsLiquidation = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;

        /* this.dataSourceLiquidationList.data.forEach((item: any) =>{
          this.getMaterialId(item.field6).then((details) => {
            item.materialDetail = details;
          });
        }) */
      },
      error: (err) => {
        this.dataSourceLiquidationList.data = [];
        this.snackBar.open(err.error.message || "Error al obtener lista de liquidaciones","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSortLiquidation(e) {
    this.sortActiveLiquidation = e.active
    this.sortDirectionLiquidation = e.direction.toUpperCase() || 'ASC'
    this.getLiquidationList()
  }

  changePageLiquidation(e: PageEvent) {
    this.pageIndexLiquidation = (e.pageIndex + 1)
    this.pageIndexLiquidation = e.pageSize
    this.getLiquidationList()
  }

  initializeCreateLiquidationList(){
    return {
      distributionChainId: "", 
      priceListId: "", 
      rangeId: "", itemId: "", 
      unitMeasureId: null, 
      currencyId: null,
      // dateStart:null, dateEnd:null, 
      price: null}
  }

  getServicesCombo(modal, type?){
    if(type) this.getPriceList()
    this.getAllSalesOrganization()
    this.setupMaterialSearchControl()
    this.getMaterialList(modal, type)
    this.getCurrency()
  }

  openCreateLiquidationList(){
    this.getServicesCombo('create', true)
    this.rangeCreateLiquidationList.reset();
    this.dialog.open(this.addLiquidationListModal, { width: '90%', disableClose: true })
    .afterClosed()
    .subscribe((result) => result && this.createLiquidationList());
  }

  createLiquidationList(){
    this.currentCreateLiquidationList = {
      ...this.currentCreateLiquidationList,
      dateStart: this.rangeCreateLiquidationList.value.start, 
      dateEnd: this.rangeCreateLiquidationList.value.end
    };

    this.createMaterialPriceList(this.currentCreateLiquidationList, this.sequenceLiquidation, ConditionClassEnum.XP01, 'L');
  }

  openEditModal(settingList: MaterialPriceListAttributes, type): void {
    const isPriceList = type === 'P';
    //consol.log("settingList", settingList)
    if(isPriceList){
      this.currentUpdatePriceList = { 
        ...settingList,
      };
      this.rangeUpdatePriceList.setValue({
        start: settingList.dateStart,
        end: settingList.dateEnd
      });
    }else{
      this.currentUpdateLiquidationList = { 
        ...settingList,
        //companyId: bank.company ? bank.company._id.toString() : ""
      };
      this.rangeUpdateLiquidationList.setValue({
        start: settingList.dateStart,
        end: settingList.dateEnd
      });
    }

    this.getServicesCombo('edit', true) //isPriceList ? true : undefined
    this.dialog.open(isPriceList ? this.editPriceListModal: this.editLiquidationModal , { width: '90%', disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.updateSettingPriceList(settingList._id.toString(), type));
  }

  updateSettingPriceList(id, type){
    if(type == 'P'){
      this.currentUpdatePriceList.dateStart = this.rangeUpdatePriceList.value.start;
      this.currentUpdatePriceList.dateEnd = this.rangeUpdatePriceList.value.end;
      this.updateMaterialPriceList(id, this.sequencePrice, this.currentUpdatePriceList, 'P')
    }else{
      this.currentUpdateLiquidationList.dateStart = this.rangeUpdateLiquidationList.value.start;
      this.currentUpdateLiquidationList.dateEnd = this.rangeUpdateLiquidationList.value.end;
      this.updateMaterialPriceList(id, this.sequenceLiquidation, this.currentUpdateLiquidationList, 'L')
    }
  }

  //global
  createMaterialPriceList(data: any, sequence: string, conditionClass: ConditionClassEnum, type) {  
    //consol.log("data:", data)
    const createPriceList: MaterialPriceListAttributes = {
      conditionClass: conditionClass,
      sequence: sequence,
      field1: data.distributionChainId || null, // org venta
      field2: null, //
      field3: null, //
      field4: data.priceListId || null, // precio lista
      field5: data.currencyId || null, // currency
      field6: data.itemId || null, // id material
      field7: data.unitMeasureId || "", // unidad de medida
      field8: data.rangeId || null, // range
      field9: null,
      field10: null,
      field11: null,
      field12: null,
      field13: null,
      // dateStart: new Date(data.dateStart).toISOString().split('T')[0],
      // dateEnd: new Date(data.dateEnd).toISOString().split('T')[0],
      // dateStart: this.rangeCreatePriceList.value.start ? new Date(this.rangeCreatePriceList.value.start).toISOString().split('T')[0] : null,
      // dateEnd: this.rangeCreatePriceList.value.end ? new Date(this.rangeCreatePriceList.value.end).toISOString().split('T')[0] : null,
      dateStart: data.dateStart || this.rangeCreatePriceList.value.start || (this.rangeCreatePriceList.value.start ? new Date(this.rangeCreatePriceList.value.start).toISOString().split('T')[0] : null),
      dateEnd: data.dateEnd || this.rangeCreatePriceList.value.end || (this.rangeCreatePriceList.value.end ? new Date(this.rangeCreatePriceList.value.end).toISOString().split('T')[0] : null),

      price: data.price, // price
      minimumPrice: 0,
      maximumPrice: 0,
      hasScalePrices: data.scalePrices && data.scalePrices.length > 0 ? true : false,
      hasMinimumAndMaximunPrices: false,
      scalePrices: data.scalePrices && data.scalePrices.length > 0 ? data.scalePrices : []
    };
  
    if(createPriceList.field1 == null || createPriceList.field6 == null){
      return;
    }

    //consol.log("createPriceList:", createPriceList)
    this.materialPriceListService.create(createPriceList).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        type == 'P' ? this.getMaterialPriceList() : this.getLiquidationList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateMaterialPriceList(id, sequence: string, data: MaterialPriceListAttributes, type){
    const updatePriceList: MaterialPriceListAttributes = {
      conditionClass: ConditionClassEnum.XP01,
      sequence: sequence,
      field1: data.field1 || "", // org venta
      field2: null, //
      field3: null, //
      field4: data.field4 || "", // precio lista
      field5: data.field5 || "", // currency
      field6: data.field6 || "", // id material
      field7: data.field7 || "", // unidad de medida
      field8: data.field8 || null, // range
      field9: null,
      field10: null,
      field11: null,
      field12: null,
      field13: null,
      // dateStart: new Date(data.dateStart).toISOString().split('T')[0],
      // dateEnd: new Date(data.dateEnd).toISOString().split('T')[0],
      // dateStart: this.rangeUpdatePriceList.value.start ? new Date(this.rangeUpdatePriceList.value.start).toISOString().split('T')[0] : null,
      // dateEnd: this.rangeUpdatePriceList.value.end ? new Date(this.rangeUpdatePriceList.value.end).toISOString().split('T')[0] : null,
      dateStart: data.dateStart || this.rangeUpdatePriceList.value.start || (this.rangeUpdatePriceList.value.start ? new Date(this.rangeUpdatePriceList.value.start).toISOString().split('T')[0] : null),
      dateEnd: data.dateEnd || this.rangeUpdatePriceList.value.end || (this.rangeUpdatePriceList.value.end ? new Date(this.rangeUpdatePriceList.value.end).toISOString().split('T')[0] : null),
      price: data.price, // price
      minimumPrice: 0,
      maximumPrice: 0,
      hasScalePrices: data.scalePrices && data.scalePrices.length > 0 ? true : false,
      hasMinimumAndMaximunPrices: false,
      scalePrices: data.scalePrices && data.scalePrices.length > 0 ? data.scalePrices : []
    };

    this.materialPriceListService.update(id, updatePriceList).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        type == 'P' ? this.getMaterialPriceList() : this.getLiquidationList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  openDeleteDialog(settingList: any, type): void {
    this.dialog
      .open(this.deleteDialog, { data: settingList, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(settingList._id.toString(), type));
  }

  delete(id, type){
    this.materialPriceListService.removeList(id).subscribe(() => {
      type == 'P' ? this.getMaterialPriceList() : this.getLiquidationList()
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    })
  }

  //filter
  getMaterialId(id){
    return new Promise((resolve) => {
      this.materialService.findOne(id).subscribe({
        next: (res: IRequestResult<MaterialAttributes>) => resolve(res.data),
        error: (err) => {
          this.snackBar.open(err.error.message || `Error fetching material details for ID ${id}`,"Cerrar",{ duration: 5000});
          resolve(null);
        },
      });
    });
  }

  getPriceListId(id){
    return new Promise((resolve) => {
      this.priceListService.findOne(id).subscribe({
        next: (res: IRequestResult<PriceListAttributes>) => resolve(res.data),
        error: (err) => {
          this.snackBar.open(err.error.message || `Error fetching price details for ID ${id}`,"Cerrar",{ duration: 5000});
          resolve(null);
        },
      });
    })
  }

  getUnitMeasureId(id){
    return new Promise((resolve) => {
      this.unitService.findOne(id).subscribe({
        next: (res: IRequestResult<UnitMeasurementsAttributes>) => resolve(res.data),
        error: (err) => {
          this.snackBar.open(err.error.message || `Error fetching unit measure details for ID ${id}`,"Cerrar",{ duration: 5000});
          resolve(null);
        },
      });
    })
  }

  //filter form
  private getAllSalesOrganization(): void {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOrganizationList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener ificianas de organización.","Cerrar",{ duration: 5000});
      },
    });
  }


  private getPriceList(): void {
    this.priceListService.findToComboBoxPriceList('P').subscribe({
      next: (res: IRequestResult<PriceListAttributes[]>) => {
        this.priceList = res.data;
        this.listFilterPriceList = this.priceList.slice()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener listas de precios.","Cerrar",{ duration: 5000});
      },
    });
  }

  changueOptionsPriceList(event){
    if (!this.priceList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterPriceList = this.priceList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterPriceList = this.priceList.filter(item => item.name.toLowerCase().indexOf(search) > -1 || item.code.toLowerCase().indexOf(search) > -1)
  }

  private getMaterialList(modal, type?): void{
    const materialOptions = {
      search: this.searchMaterial ? this.searchMaterial: (this.data.code ? this.data.code : null),
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    const companyCodes = [environment.companyId];
    //const salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)

    this.materialService.findAllComboWithCount(
      materialOptions,
      companyCodes,
      null, //modal == 'edit' ? (type ? this.currentUpdatePriceList.field6 : this.currentUpdateLiquidationList.field6): null
    ).subscribe({
      next: (res: IRequestResult<MaterialAttributes[]>) => {
        this.materialList = res?.data ?? [];

        this.currentCreatePriceList.itemId = this.data ? this.data.materialId  : ""
        this.currentCreateLiquidationList.itemId = this.data ? this.data.materialId  : ""
        this.getUnitMeasureList()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener materiales.","Cerrar",{ duration: 5000});
      },
    })
  }

  changueOptionsMaterial(event){
    this.searchSubject.next(event);
  }

  private setupMaterialSearchControl(): void {
    this.searchSubject
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
    .subscribe((searchTerm) => {
      if(searchTerm){
        this.searchMaterial = searchTerm;
        this.getMaterialList(null);
      }
    });
  }

  trackByFn(index: number, item: any): any {
    return item._id || index;
  }

  getUnitMeasureList(){
    const selectedItem = this.materialList.find(item => item._id === this.currentCreatePriceList.itemId);

    if(selectedItem){
      if(selectedItem.alternalUnitOfMeasures && selectedItem.alternalUnitOfMeasures.length >= 0){
        const baseUnitFound = selectedItem.alternalUnitOfMeasures.some(um => um.unitOfMeasure._id === selectedItem.baseUnitOfMeasure._id);
  
        // Si no está, agregar baseUnitOfMeasure al inicio
        if (!baseUnitFound) {
          selectedItem.alternalUnitOfMeasures.unshift({
            isUMB: true,
            isUMP: false,
            quantity: 1,
            equivalentQuantity: 1,
            conversionFactor: 1,
            barcode: "",
            price: null,
            unitOfMeasure: {
              _id: selectedItem.baseUnitOfMeasure._id,
              code: selectedItem.baseUnitOfMeasure.code,
              name: selectedItem.baseUnitOfMeasure.name,
              statusId: selectedItem.baseUnitOfMeasure.statusId,
              //_deleted: false
            }
          });
        }
      }else if(selectedItem.baseUnitOfMeasure){
        selectedItem.alternalUnitOfMeasures.unshift({
          isUMB: true,
          isUMP: false,
          quantity: 1,
          equivalentQuantity: 1,
          conversionFactor: 1,
          barcode: "",
          price: null,
          unitOfMeasure: {
            _id: selectedItem.baseUnitOfMeasure._id,
            code: selectedItem.baseUnitOfMeasure.code,
            name: selectedItem.baseUnitOfMeasure.name,
            statusId: selectedItem.baseUnitOfMeasure.statusId,
          }
        });
      }
  
      this.unitMeasureList = selectedItem.alternalUnitOfMeasures
    }
  }

  getCurrency(){
    const query = buildQuery<CompanyAttributes>(
      where("id", Ops.eq(environment.companyId)),
    )

    this.companyService.fetchCompany(query).subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        let company = res.data && res.data.length > 0 ? res.data[0]: null;
        if(company && company.currencyBase){
          this.listFilterCurrency = [company.currencyBase]
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener moneda.","Cerrar",{ duration: 5000});
      },
    });
  }

  rangeCreatePriceList = new FormGroup({
    start: new FormControl(null),
    end: new FormControl(null)
  });
  
  rangeUpdatePriceList = new FormGroup({
    start: new FormControl(null),
    end: new FormControl(null)
  });
  
  rangeCreateLiquidationList = new FormGroup({
    start: new FormControl(null),
    end: new FormControl(null)
  });
  
  rangeUpdateLiquidationList = new FormGroup({
    start: new FormControl(null),
    end: new FormControl(null)
  });
}
